import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export const usePostOrderPhotoCheck = () => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (order_idx: string) => {
            const response = await axios.post(
                enum_api_uri.post_order_photo_check.replace(":order_idx", order_idx),
                {},
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getOrderHistory"] });
            // 목록의 photo_checked 가 바뀌므로 함께 다시 받아 점멸을 멈춘다
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            // 요약바의 사진미확인 건수도 같은 기준으로 세므로 함께 갱신한다
            queryClient.invalidateQueries({ queryKey: ["getOrderCount"] });
        },
    });
};
